import { useQuery } from '@tanstack/react-query';
// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { getAppointmentHistory } from '../../Customers/apiService';

import AppointmentHistory from '../../Customers/Components/AppointmentHistory';


const Customer = () => {
  const { data = {} } = usePageData();

  const { data: history } = useQuery({
    queryKey: ['customers', data.customer_id],
    queryFn: () => getAppointmentHistory(data.customer_id),
    enabled: !!data.customer_id
  })
  console.log(history, "history");
  return (
    <div>
     <AppointmentHistory history={history} client_name={data.client_name} />
    </div>
  );
};

export default Customer;